import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import { COLOR_WHITE } from '../templates/colors';
import queryString from 'query-string';

const ROOT_WIDTH = 900;
const ROOT_HEIGHT = 600;
const PIXEL_DENSITY_FACTOR = 2;
const getScaleFactor = (props)=> props && !isNaN(props.scaleFactor) ? props.scaleFactor : PIXEL_DENSITY_FACTOR;

const useStyles = makeStyles((theme)=> ({
    root: {
        width: (props)=> ROOT_WIDTH * getScaleFactor(props),
        height: (props)=> ROOT_HEIGHT * getScaleFactor(props),
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: COLOR_WHITE,
        textRendering: 'optimizeLegibility',
        borderRadius: (props)=> props && props.borderRadius ? props.borderRadius : 0,
        zoom: ({ templateRootZoom })=> templateRootZoom,
    },
    viewport: {
        display: 'block',
        position: 'relative',
        width: '100%',
        height: '100%',
        zoom: (props)=> getScaleFactor(props),
    },
}));

export function useShareablesTemplateRoot(props){
    const location = useLocation();
    let parsedData = props.data || null;
    let currentFrame = props.frame || 1;
    let templateRootZoom = props.zoom || 1;
    const onImagesLoaded = props.onImagesLoaded;
    if(!parsedData) {
        try {
            const { data, frame, zoom } = queryString.parse(location.search);
            parsedData = JSON.parse(data);
            currentFrame = parseInt(frame, 10);
            if(zoom && !isNaN(parseFloat(zoom))) templateRootZoom = parseFloat(zoom);
        } catch(e) {
            console.error(e);
        }
    }
    const rootClasses = useStyles({ templateRootZoom, ...props });

    return {
        rootClasses,
        parsedData,
        currentFrame,
        onImagesLoaded
    };
}